/**
 * Mobile Navigation 
 */

export function axMobileMenu() {
	// console.log( 'Mobile Menu invoked...' );
	const jQuery = window.jQuery;

	if ( jQuery( 'body' ).width() < 1201 ) {
		// click event - menu trigger element
		jQuery( '.js-mobile-menu-trigger' ).click( function ( event ) {
			event.preventDefault();
			jQuery( '.js-mobile-menu-content' ).toggleClass( 'is-open' );
			jQuery( 'body' ).toggleClass( 'ax--hide-scroll' );
		} );

		// UI interaction for sub menu
		jQuery( '#site-navigation-mobile .menu-item-has-children' ).append( `
        <span class="_submenu-trigger js-mobile-submenu-trigger"></span>` );

		// click event on append HTML element
		jQuery( '#site-navigation-mobile .js-mobile-submenu-trigger' ).on(
			'click',
			function ( event ) {
				event.preventDefault();
				jQuery( this ).toggleClass( 'is-open' );
				jQuery( this ).siblings( '.sub-menu' ).toggle( 'slow' );
			}
		);
	}
}
